import { render, staticRenderFns } from "./PharmacyDutyAdmin.vue?vue&type=template&id=6ac1b95c&scoped=true&lang=pug"
import script from "./PharmacyDutyAdmin.vue?vue&type=script&lang=js"
export * from "./PharmacyDutyAdmin.vue?vue&type=script&lang=js"
import style0 from "./PharmacyDutyAdmin.vue?vue&type=style&index=0&id=6ac1b95c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac1b95c",
  null
  
)

export default component.exports